export default __webpack_public_path__ + "static/logo-white-c348169776a968df879b2bd110823146.png";